














































import { Component, Vue } from 'vue-property-decorator'
import HeadLable from '@/components/HeadLable/index.vue'
import { UserModule } from '@/store/modules/user'
import { queryLevel } from '@/api/order'
import { addData,queryData } from '@/api/setMeal'
@Component({
  components: {
    HeadLable
  },
})
export default class extends Vue {
  private timeValue: any = []
  private timeValue2: any = []
  private pickDate : any = ''
  private undisabledDates: string[] = []; // 存储被解禁的日期
  private dateParam: string[] = []; // 存储被禁的日期
  private level = 4


  private pickerOptions= {
    shortcuts: [
      {
        text: '最近一周',
        onClick(picker) {
          const end = new Date();
          const start = new Date(new Date().getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit('pick', [start, end]);
        }
      }, {
        text: '最近一个月',
        onClick(picker) {
          const end = new Date();
          const start = new Date(new Date().getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit('pick', [start, end]);
        }
      }, {
        text: '最近三个月',
        onClick(picker) {
          const end = new Date();
          const start = new Date(new Date().getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit('pick', [start, end]);
        }
      }],
    disabledDate:(time) =>{
      const date = new Date(time);
      date.setHours(0, 0, 0, 0); // 将时间设置为午夜，以便比较日期

      // 检查是否是今天之前的日期
      const today = new Date();
      today.setHours(0, 0, 0, 0); // 将今天的时间设置为午夜
      const isBeforeToday = date < today;

      // 检查是否是周末（周六或周日）
      const isWeekend = date.getDay() === 0 || date.getDay() === 6;

      // 检查是否在解禁日期列表中
      const isUndisabledDate = this.undisabledDates.some(param => {
        const paramDate = new Date(param);
        paramDate.setHours(0, 0, 0, 0); // 将解禁日期的时间设置为午夜
        return paramDate.getTime() === date.getTime();
      });

      // 检查是否在禁用日期列表中
      const isDisabledDate = this.dateParam.some(param => {
        const paramDate = new Date(param);
        paramDate.setHours(0, 0, 0, 0); // 将禁用日期的时间设置为午夜
        return paramDate.getTime() === date.getTime();
      });
      console.log("1111日期dateParam"+this.dateParam)
      // 如果任何一个条件为真，则返回true禁用日期
      return isBeforeToday || (isWeekend && !isUndisabledDate) || isDisabledDate;
    }


}
  created(){
    this.init()

}
  init(){
    this.initGetData()
    this.getLevel()

  }
  getLevel(){
    const username = UserModule.username
    queryLevel(username)
      .then((res)=>{
        if (res.data.code === 1) {
          this.level=res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
        return this.level;

      })
      .catch((err) => {
        this.$message.error('请求出错了：' + err.message)
      })
  }
  initGetData(){
    queryData()
      .then((res)=>{
      if (res.data.code === 1) {

        this.dateParam=JSON.parse(res.data.data.data)
        this.undisabledDates =JSON.parse(res.data.data.noWeekends)
        console.log("3333getData"+this.dateParam)
        this.pickerOptions= {
          shortcuts: [
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date();
                const start = new Date(new Date().getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date(new Date().getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date(new Date().getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit('pick', [start, end]);
              }
            }],
          disabledDate:(time) =>{
            const date = new Date(time);
            date.setHours(0, 0, 0, 0); // 将时间设置为午夜，以便比较日期

            // 检查是否是今天之前的日期
            const today = new Date();
            today.setHours(0, 0, 0, 0); // 将今天的时间设置为午夜
            const isBeforeToday = date < today;

            // 检查是否是周末（周六或周日）
            const isWeekend = date.getDay() === 0 || date.getDay() === 6;

            // 检查是否在解禁日期列表中
            const isUndisabledDate = this.undisabledDates.some(param => {
              const paramDate = new Date(param);
              paramDate.setHours(0, 0, 0, 0); // 将解禁日期的时间设置为午夜
              return paramDate.getTime() === date.getTime();
            });

            // 检查是否在禁用日期列表中
            const isDisabledDate = this.dateParam.some(param => {
              const paramDate = new Date(param);
              paramDate.setHours(0, 0, 0, 0); // 将禁用日期的时间设置为午夜
              return paramDate.getTime() === date.getTime();
            });
            console.log("1111日期dateParam"+this.dateParam)
            // 如果任何一个条件为真，则返回true禁用日期
            return isBeforeToday || (isWeekend && !isUndisabledDate) || isDisabledDate;
          }


        }
      }

    })
      .catch((err) => {
        this.$message.error('请求出错了：' + err.message)
      })

  }
  setData(){
    console.log("this.dataParam"+this.dateParam)
    console.log("this.undisabledDates"+this.undisabledDates)
    const serializedArray1 = JSON.stringify(this.dateParam);
    const serializedArray2 = JSON.stringify(this.undisabledDates);
    const data ={data: serializedArray1, noWeekends:serializedArray2}
    console.log(data)
    addData(data)
      .then((res)=>{
      if (res.data.code === 1) {
        this.init();
        this.$message.success("禁用成功")
      }
    })
      .catch((err) => {
        this.$message.error('请求出错了：' + err.message)
      })

  }


  getData(){
    queryData()
      .then((res)=>{
      if (res.data.code === 1) {

        this.dateParam=JSON.parse(res.data.data.data)
        this.undisabledDates =JSON.parse(res.data.data.noWeekends)
      }

    })
      .catch((err) => {
        this.$message.error('请求出错了：' + err.message)
      })

  }


  // 如果需要处理选择日期后的逻辑，在时间列表中加入选择的日期，然后在日期选择器中禁用
// 将日期格式化为 'YYYY-MM-DD' 格式的字符串
  private formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  // 遍历日期范围并将每个日期添加到 dateParam 数组中
  private addDatesToParam(beginTime: string, endTime: string): void {
    beginTime = this.timeValue[0]
    endTime=this.timeValue[1]
    // 将字符串日期转换为Date对象
    const startDate = new Date(beginTime);
    const endDate = new Date(endTime);

    // 确保开始日期不晚于结束日期
    if (startDate > endDate) {
      console.error('开始日期不能晚于结束日期');
      return;
    }

    let current = new Date(startDate);
    while (current <= endDate) {
      const dateString = this.formatDate(current);
      if (!this.dateParam.includes(dateString)) {
        this.dateParam.push(dateString);// 使用响应式方法更新 dateParam
      }
      current.setDate(current.getDate() + 1);
    }

    this.setData()
  }
//权限获取

// 移除日期范围的禁用
  private removeDatesFromParam(beginTime: string, endTime: string): void{
    beginTime = this.timeValue2[0]
    endTime=this.timeValue2[1]
    const startDate = new Date(beginTime);
    const endDate = new Date(endTime);

    // 循环遍历从开始日期到结束日期的每一天
    let current = new Date(startDate);
    while (current <= endDate) {
      const dateString = this.formatDate(current);
      // 检查当前日期是否是周末
      if (current.getDay() === 0 || current.getDay() === 6) {
        // 如果是周末，则添加到 undisabledDates 数组中
        const index = this.undisabledDates.indexOf(dateString);
        if (index === -1) {
          this.undisabledDates.push(dateString);
        }
      }
      //去除dateParam中禁用的日期
      const index = this.dateParam.indexOf(dateString);
      if (index > -1) {
        this.dateParam.splice(index, 1); // 使用响应式方法移除元素，否则无法实时加载到日期选择器
      }
      current.setDate(current.getDate() + 1);
    }
    this.setData()

  }
  getPickDate() {
    const params = {
      beginTime:
        this.timeValue && this.timeValue.length > 0
          ? this.timeValue[0]
          : undefined,
      endTime:
        this.timeValue && this.timeValue.length > 0
          ? this.timeValue[1]
          : undefined
    }
    const { beginTime, endTime } = params || {};
    console.log({beginTime, endTime})
    if (!beginTime || !endTime) {
      this.$message.error('请选择日期范围');
      return;
    }

    this.$confirm('确认禁用所选日期吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      this.addDatesToParam(params[0], params[1]); // 添加日期范围到 dateParam
      this.$message({
        type: 'success',
        message: '禁用日期范围成功!',
      });
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '已取消禁用日期',
      });
    });
  }

// 确认取消禁用日期后调用的方法
  private getUnpickDate() {
    const params = {
      beginTime:
        this.timeValue2 && this.timeValue2.length > 0
          ? this.timeValue2[0]
          : undefined,
      endTime:
        this.timeValue2 && this.timeValue2.length > 0
          ? this.timeValue2[1]
          : undefined
    }
    const { beginTime, endTime } = params || {};
    console.log({ beginTime, endTime });

    if (!beginTime || !endTime) {
      this.$message.error('请选择日期范围');
      return;
    }

    this.$confirm('确认取消禁用所选日期吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      // 从 dateParam 中移除日期范围
      this.removeDatesFromParam(params[0], params[1]);
      this.$message({
        type: 'success',
        message: '取消禁用日期范围成功!',
      });
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '已取消取消禁用日期',
      });
    });
  }
  disabledDate(date) {
    const { minDate, maxDate } = this.pickDate
    if (minDate && !maxDate) {
      const diff = Math.abs(minDate.valueOf() - date.valueOf())
      // 日期选择范围不能大于一年
      if (diff > 1000 * 3600 * 24 * 365) {
        return true
      }
    }
  }
}

